import { render, staticRenderFns } from "./CreateOrUpdateBillingAddress.vue?vue&type=template&id=5d193740&"
import script from "./CreateOrUpdateBillingAddress.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateBillingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports